import styled from 'styled-components';
import { breakpoints } from 'styles/breakpoints';

export const StyledSpecialOfferPriceButton = styled.div.attrs({
  className: 'specialOfferPriceButton',
})`
  background: #0c7348;
  box-shadow: 0px 4px 2px 0px rgba(255, 255, 255, 0.25) inset;
  border: 2px solid rgba(33, 42, 89, 0.8);
  position: relative;
  border-radius: 20px;
  padding: 5px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 16px;
  overflow: hidden;
  min-width: 65px;
  max-width: 100%;
` as any;

export const StyledSpecialOfferPrice = styled.div<{
  buttonTextColor: string;
}>`
  display: flex;
  direction: ltr;
  justify-content: center;
  width: 100%;
  color: ${({ buttonTextColor }) => buttonTextColor};
  position: relative;

  .decoration {
    padding: 10px;
    width: 120%;
    background: #17ca67;
    border-radius: 20px;
    position: absolute;
    top: -11px;
  }

  .totalPrice {
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10;
    white-space: nowrap;

    .stroked {
      text-decoration-line: line-through;
      text-decoration-color: #d8232a;
      text-decoration-thickness: 2px;
      display: flex;
      align-items: center;
      font-size: 12px;
    }

    @media (width < ${breakpoints.mobileS}) {
      font-size: 12px;
    }
  }
` as any;
